import initializeAdjacentAndConflictingMeetingsAction from '../actions/initializeAdjacentAndConflictingMeetingsAction';
import setConflictsRequestStatus from '../actions/setConflictsRequestStatus';
import RequestStatus from '../store/schema/RequestStatus';
import { orchestrator } from 'satcheljs';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { featureId } from '../utils/meetingConflictsPropertyEntry';
import Item from 'owa-service/lib/contract/Item';

export default orchestrator(initializeAdjacentAndConflictingMeetingsAction, async actionMessage => {
    const { item, meetingRequestViewState } = actionMessage;

    setConflictsRequestStatus(RequestStatus.Pending, meetingRequestViewState);
    let updatedItem: Item = null;
    try {
        const getItemProperties = await lazyGetItemProperties.import();
        updatedItem = await getItemProperties(item.ItemId.Id, featureId);

        if (updatedItem) {
            setConflictsRequestStatus(RequestStatus.Complete, meetingRequestViewState);
        } else {
            setConflictsRequestStatus(RequestStatus.Error, meetingRequestViewState);
        }
    } catch (e) {
        // Mark request as failed
        setConflictsRequestStatus(RequestStatus.Error, meetingRequestViewState);
    }
});
